import {inject, customAttribute, TaskQueue} from 'aurelia-framework'

@customAttribute('auto-focus')
@inject(Element, TaskQueue)

export class AutoFocus {
    constructor(private element: Element, private taskQueue: TaskQueue) {

    }

    attached() {
        this.taskQueue.queueTask(() => {
            var inputs = this.element.tagName == "INPUT" ? [this.element] : this.element.getElementsByTagName('input');
            if (inputs.length > 0) {
                let input: HTMLInputElement = inputs[0] as HTMLInputElement;
                input.focus();
            }
            else {
                console.warn('No input element found for auto-focus');
            }
        });

    }
}